import { cn } from "@/utils/cn";
export {
  activeTabStyles,
  fieldStyles,
  interactiveStyles,
  primaryButtonStyles,
  secondaryButtonStyles,
  tabButtonStyles,
} from "@/styles/controlStyles";

export const appPageStyles = cn(
  "mx-auto min-h-[calc(100vh-202px)] min-w-0 w-[min(var(--content-width),calc(100%-2*var(--page-gutter)))]",
  "max-[42.5rem]:w-[calc(100%-1.5rem)]",
);

export const sectionIndexStyles =
  "font-mono text-label leading-normal font-bold tracking-label text-primary uppercase";

export const panelCardStyles = cn(
  "@container min-w-0 rounded-card border border-border bg-surface p-6 shadow-card",
  "max-[42.5rem]:p-[18px]",
);

export const panelHeadingStyles = cn(
  "flex min-w-0 items-center justify-between",
  "@max-2xl:items-start @max-2xl:gap-4",
  "max-[42.5rem]:w-full max-[42.5rem]:flex-col max-[42.5rem]:items-start max-[42.5rem]:gap-3.5",
);

export const metricCardStyles = cn(
  "@container flex min-w-0 flex-col rounded-[8px] border border-border bg-surface p-5 shadow-card",
  "max-[42.5rem]:p-[17px]",
  "focus-within:border-primary focus-within:ring-2 focus-within:ring-ring/20",
);
